import { createReducer, on } from '@ngrx/store';
import { PHASE_ONE } from '../../../model/phases.model';
import * as phaseOneAction from './phase-one-actions';

export const phaseOneInitialState: PHASE_ONE = {
  ThreeData: undefined,
  DoneBySkip: false,
};

export const phaseOneReducer = createReducer(
  phaseOneInitialState,
  on(phaseOneAction.ADD_PHASE_ONE, (state: PHASE_ONE, { payload }) => {
    return { ...payload };
  })
  // on(phaseOneAction.GET_PHASE_ONE_DATA, (state: PHASE_ONE) => state)
);
